import React, { useState, useEffect, useContext } from "react";
//
import { IntlProvider } from "react-intl";
//
import PropTypes from "prop-types";
import { StoreContext } from "../store/StoreProvider";
//
import urls from "../api/project/ApiUrls";
//
import messages from "./messages";

const LOCALE_LANG = urls.locale_lang;

const IntlProviderHOC = ({ children }) => {
  const [state, dispatch] = useContext(StoreContext);
  const { locale } = state.user;
  const [localLocale, setLocalLocale] = useState(locale);
  const [localeReady, setLocaleReady] = useState(false);

  // 語系
  useEffect(() => {
    /* FIXME: 或許把 locale 變成個人的設定 */
    // 在 react-intl 中只有 zh，並無 zh-hans
    const intlLocale = locale.startsWith("zh") ? "zh" : locale;
    setLocalLocale(intlLocale);
    urls.setLocale(locale);
    setLocaleReady(true);
  }, [locale]);

  return (
    <IntlProvider
      locale={localLocale}
      defaultLocale={LOCALE_LANG.LOCALE_DEFAULT}
      messages={messages[localLocale]}
    >
      {children}
    </IntlProvider>
  );
};

IntlProviderHOC.propTypes = {
  children: PropTypes.node,
};

IntlProviderHOC.defaultProps = {
  children: null,
};

export default IntlProviderHOC;
